import messages from './messages';

export const testimonialItems = [
	{
		testimonial: messages.celeseTestimonial,
		name: messages.celesteName,
		memberSince: messages.celesteDate,
		thumbnail: '/_n/images/discount-landing/celeste-avatar.webp',
	},
	{
		testimonial: messages.jtTestimonial,
		name: messages.jtName,
		memberSince: messages.jtDate,
		thumbnail: '/_n/images/discount-landing/jt-avatar.webp',
	},
	{
		testimonial: messages.alisonTestimonial,
		name: messages.alisonName,
		memberSince: messages.alisonDate,
		thumbnail: '/_n/images/discount-landing/alison-avatar.webp',
	},
];
